<!-- ======= Portfolio Section ======= -->
<section id="portfolio" class="portfolio section-bg">
  <div class="container" data-aos="fade-up">
    <div class="section-title">
      <h2>Portafolio</h2>
      <p>Algunos de los proyectos personales en los que estuve trabajando.</p>
    </div>

    <div class="row">
      <div
        class="col-lg-12 d-flex justify-content-center"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <ul id="portfolio-flters">
          <li id="all" #all data-filter="*">Todos</li>
          <li data-filter=".filter-app">Angular</li>
          <li data-filter=".filter-card">React</li>
        </ul>
      </div>
    </div>

    <div
      class="row portfolio-container"
      data-aos="fade-up"
      data-aos-delay="200"
    >
      <div
        *ngFor="let app of portfolio"
        class="col-lg-4 col-md-6 portfolio-item"
        [ngClass]="app.class"
      >
        <div class="portfolio-wrap">
          <img
            [src]="app.img"
            class="img-fluid"
            [alt]="app.name"
            loadin="lazy"
          />
          <div class="portfolio-info">
            <h4>{{ app.name }}</h4>

            <div class="portfolio-links">
              <a
                [href]="app.web"
                target="_blank"
                data-gallery="portfolioGallery"
                class="portfolio-lightbox"
                [title]="app.name"
                ><i class="bx bx-plus"></i
              ></a>
              <a
                [href]="app.github"
                target="_blank"
                class="portfolio-details-lightbox"
                data-glightbox="type: external"
                [title]="app.name"
                ><i class="bx bx-link"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Portfolio Section -->
